import {
  CASE_FETCH_FILE_VERSIONS_BEGIN,
  CASE_FETCH_FILE_VERSIONS_SUCCESS,
  CASE_FETCH_FILE_VERSIONS_FAILURE,
  CASE_FETCH_FILE_VERSIONS_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const fetchFileVersions = createPromiseAction(CASE_FETCH_FILE_VERSIONS_BEGIN);

export function dismissFetchFileVersionsFeedback() {
  return {
    type: CASE_FETCH_FILE_VERSIONS_DISMISS_FEEDBACK,
  };
}

export function* doFetchFileVersions(action) {
  const { caseId, fileId } = action.payload;

  let res = yield call(api.get, `/cases/${caseId}/files/${fileId}/versions?includeAll=true`);

  if (res && res.error) {
    yield put({
      type: CASE_FETCH_FILE_VERSIONS_FAILURE,
      feedback: {
        message: 'feedback.fetchFileVersionsFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_FETCH_FILE_VERSIONS_SUCCESS,
    data: { fileVersions: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchFetchFileVersions() {
  yield takeLatest(fetchFileVersions, withCurrentCaseId(doFetchFileVersions));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_FETCH_FILE_VERSIONS_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        fetchFileVersionsPending: true,
        fetchFileVersionsFeedback: null,
      };

    case CASE_FETCH_FILE_VERSIONS_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchFileVersionsPending: false,
        fetchFileVersionsFeedback: action.feedback,
      };

    case CASE_FETCH_FILE_VERSIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchFileVersionsPending: false,
        fetchFileVersionsFeedback: action.feedback,
      };

    case CASE_FETCH_FILE_VERSIONS_DISMISS_FEEDBACK:
      // Dismiss the request failure Feedback
      return {
        ...state,
        fetchFileVersionsFeedback: null,
      };

    default:
      return state;
  }
}
